import { createGenericSlice, GenericActions, GenericState } from "../GenericSlice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export type ExportDocumentType = {
    id: string;
    RequestedOn: Date | null;
    StartDate: Date | null;
    EndDate: Date | null;
    Status: string;
    doc_url: string | null;
    exportType: string | null;
    month: number | null;
    year: number | null;
}


type State = {
    data: ExportDocumentType[];
}

const initialState: State = {
    data: []
}

const ExportsDataSlice = createGenericSlice({
    name: "ExportsDataSlice",
    initialState: initialState as GenericState<ExportDocumentType[]>,
    reducers: {
        success: {
            reducer: (state, action: PayloadAction<ExportDocumentType[]>) => {


                state.data = action.payload;
                state.status = 'finished'
            },
            prepare: ({data : Subscription}) => {

                Subscription = Subscription || [];
                const ExportDocumentArray: ExportDocumentType[] = Subscription.map((data: any) => {

                    return {
                        id: data.id,
                        RequestedOn: data.RequestedOn ? new Date(data.RequestedOn.seconds * 1000).toLocaleString() : null,
                        StartDate: data.StartDate ? new Date(data.StartDate.seconds * 1000).toLocaleDateString() : null,
                        EndDate: data.EndDate ? new Date(data.EndDate.seconds * 1000).toLocaleDateString() : null,
                        Status: data.Status,
                        doc_url: data.doc_url || null,
                        exportType: data.exportType || null,
                        month: data.month || null,
                        year: data.year || null
                    }
                })

                return { payload: ExportDocumentArray }

            }
        }
    }
})

export const actions = ExportsDataSlice.actions as unknown as GenericActions<ExportDocumentType[]> 
export default ExportsDataSlice.reducer